// extracted by mini-css-extract-plugin
export var quillEditor = "_mm-1";
export var variable = "_mm-0";